module.exports = __webpack_public_path__ + "static/media/homeImg.64c8e63d.svg";